/* istanbul ignore file */
/**
 * Toggle button component theme configuration.
 */

export const toggleButtonComponentConfig = {
  togglebutton: {
    root: {
      padding: '5px 16px',
      borderRadius: '{border.radius.sm}',
      gap: '8px',
      fontWeight: '400',
      background: '{surface.0}',
      borderColor: '{primary.color}',
      color: '{primary.color}',
      hoverBackground: '{coralreef.500}',
      hoverColor: '{primary.color}',
      checkedBackground: '{primary.color}',
      checkedColor: '{surface.0}',
      checkedBorderColor: '{primary.color}',
      disabledBackground: '{surface.0}',
      disabledBorderColor: '{surface.200}',
      disabledColor: '{surface.200}',
      invalidBorderColor: '{form.field.invalid.border.color}',
      focusRing: {
        width: '{form.field.focus.ring.width}',
        style: '{form.field.focus.ring.style}',
        color: '{form.field.focus.ring.color}',
        offset: '{form.field.focus.ring.offset}',
        shadow: '{form.field.focus.ring.shadow}',
      },
      transitionDuration: '{form.field.transition.duration}',
      sm: {
        fontSize: '14px',
        padding: '3px 10px',
      },
      lg: {
        fontSize: '14px',
        padding: '9px 20px',
      },
    },
    icon: {
      color: '{primary.color}',
      hoverColor: '{primary.color}',
      checkedColor: '{surface.0}',
      disabledColor: '{surface.200}',
    },
    content: {
      left: '40px',
      top: '40px',
      checkedBackground: '{primary.color}',
      checkedShadow: 'none',
    },
    colorScheme: {
      light: {
        root: {
          hoverBackground: '{surface.50}',
        },
      },
    },
  },
};
